import type { UserProps } from '@img-arena/consoles-api-dde'
import { ddeApi } from '@/service/ddeApi'

import { createBaseTableStore } from '../table'
import type { FetchApiArgs, FetchApiResponse } from '../table/table.types'

const fetchDDEUsersApiCallback = async (
  args: FetchApiArgs<unknown, string, string>
): Promise<FetchApiResponse<UserProps>> => {
  const { signal } = args

  const {
    data: { users }
  } = await ddeApi.endpoints.users.getAll(signal)

  return {
    content: users,
    totalElements: users.length
  }
}

export const useUsersStoreDDE = createBaseTableStore({
  storeName: 'DDE Users',
  fetchApi: fetchDDEUsersApiCallback
})
